// extracted by mini-css-extract-plugin
export default {"selectWrap":"wcHPJJgr","select":"fIxqmvhB","icon":"YUb4UHy8"};